module.exports = __webpack_public_path__ + "img/petinder.8a90e21b.svg";